import React, { ReactNode } from "react";
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import styles from "./Table.module.scss";
import cn from "classnames";
import Checkbox from "../Checkbox";

interface Column {
  id: string;
  label: string | ReactNode;
  isIconInColumn?: React.ReactElement;
  renderCell?: (columnId: string) => ReactNode;
}

interface TableProps {
  columns: Column[];
  data?: { [key: string]: any }[];
  renderCell?: (
    cellData: any,
    columnId: string,
    row: any,
    openDelete?: (id: number) => void
  ) => ReactNode;
  onRowClick?: (data: any) => void;
  openDelete?: (id: number) => void;
  isInDetail?: boolean;
  containerClassName?: string;
  onHeadCheckClick?: (checked: boolean) => void;
  isAllChecked?: boolean;
  selectedRowsArray?: any[];
  selectedRows?: Set<any>;
  onRowCheckClick?: (id: string | number, checked: boolean) => void;
  onRowCheckClickItems?: (id: any, checked: boolean) => void;
  isArrayClickItems?: boolean;
  rowCheckId?: string;
  isHideCheckbox?: boolean;
}

const Table: React.FC<TableProps> = ({
  columns,
  data,
  renderCell,
  onRowClick,
  openDelete,
  isInDetail,
  containerClassName,
  onHeadCheckClick,
  isAllChecked,
  isHideCheckbox = false,
  rowCheckId = "id",
  selectedRows = new Set(),
  onRowCheckClick,
}) => {
  const onChangeHeaderCheckbox = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onHeadCheckClick?.(event.target.checked);
  };

  const onChangeRowCheckbox = (
    id: string | number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onRowCheckClick?.(id, event.target.checked);
  };

  return (
    <div className={cn(styles.container, containerClassName)}>
      <div
        className={cn(
          styles.tableWrapper,
          isInDetail && styles.tableWrapper_inDetail
        )}
      >
        <MuiTable
          className={cn(
            styles.table,
            isInDetail && styles.table_inDetail,
            onRowClick && styles.table_linked
          )}
        >
          <TableHead style={{ width: "100%" }}>
            <TableRow>
              {columns?.map((column) => {
                if (column.id === "checkbox") {
                  return (
                    <TableCell key={column.id}>
                      <Checkbox
                        name="header-checkbox"
                        checked={isAllChecked}
                        onChange={onChangeHeaderCheckbox}
                      />
                    </TableCell>
                  );
                }
                return (
                  <TableCell key={column.id}>
                    {column.isIconInColumn ? (
                      <div className={styles.iconInColumnWrapper}>
                        {column.isIconInColumn}{" "}
                        {column.renderCell
                          ? column.renderCell(column.id)
                          : column.label}
                      </div>
                    ) : column.renderCell ? (
                      column.renderCell(column.id)
                    ) : (
                      column.label
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {Array.isArray(data) &&
              data.map((row, index) => (
                <TableRow
                  sx={{ marginTop: "5px" }}
                  key={row.id}
                  onClick={() => onRowClick?.(row)}
                >
                  {columns?.map((column) => {
                    if (column.id === "checkbox" && !isHideCheckbox) {
                      return (
                        <TableCell key={column.id}>
                          <Checkbox
                            name={`row-checkbox-${String(row[rowCheckId])}`}
                            checked={selectedRows.has(row[rowCheckId])}
                            onChange={(e) => {
                              onChangeRowCheckbox(row[rowCheckId], e);
                            }}
                          />
                        </TableCell>
                      );
                    }

                    if (column.id === "index") {
                      return <TableCell key={column.id}>{index + 1}</TableCell>;
                    }

                    return (
                      <TableCell
                        key={column.id}
                        className={
                          column.id === "description" ? styles.description : ""
                        }
                      >
                        {column.id === "description" ? (
                          <div className={styles.descriptionScroll}>
                            {row[column.id]}
                          </div>
                        ) : renderCell ? (
                          renderCell(row[column.id], column.id, row, openDelete)
                        ) : (
                          row[column.id]
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
          </TableBody>
        </MuiTable>
      </div>
    </div>
  );
};

export default Table;
